import {createSlice} from '@reduxjs/toolkit';

export const dashOffice = createSlice({
    name: 'dashOfficeDetails',
    initialState: {
        // value: !process.env.NODE_ENV || process.env.NODE_ENV === 'development' ?  'http://localhost/IntelAgentApi/' :
        //         'http://dev.intelagentservices.com.au/api/'
        officeId:  0,
        officeName: 'All Offices',
    },
    reducers: {
        // increment: (state) => {
        //     // Redux Toolkit allows us to write "mutating" logic in reducers. It
        //     // doesn't actually mutate the state because it uses the Immer library,
        //     // which detects changes to a "draft state" and produces a brand new
        //     // immutable state based off those changes.
        //     // Also, no return statement is required from these functions.
        //     state.value += 1
        //   },
        //   decrement: (state) => {
        //     state.value -= 1
        //   },
        //   incrementByAmount: (state, action) => {
        //     state.value += action.payload
        //   },
        updateSelectedOffice: (state, action) => {
            state.officeId = action.payload.officeId;
            state.officeName = action.payload.officeName;
        }
    },
})

// Action creators are generated for each case reducer function
// export const { increment, decrement, incrementByAmount } = apiPath.actions
export const { updateSelectedOffice } = dashOffice.actions
export default dashOffice.reducer